import { Link } from "react-router-dom";
import { Sparkles, Scissors, Truck, Store } from "lucide-react";
import { Seo } from "@/components/Seo";

const HERO_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_kurti-showcase-7/artifacts/fu7jd0db_IMG_4383.png";

export default function About() {
  return (
    <div className="bg-[#FAFAF7]" data-testid="about-page">
      <Seo
        title="About Us — Kurti Connection USA"
        description="Kurti Connection USA is a family-run Indian ethnic wear boutique in Schaumburg, IL — handpicked kurtis, sarees and wedding wear, in-house alterations, and same-day local delivery."
        path="/about"
      />
      <div className="max-w-[1100px] mx-auto px-5 py-14 sm:py-20">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="overline text-[#B84A3B]">Our story</div>
            <h1 className="font-display text-4xl sm:text-5xl tracking-tight mt-2 leading-tight">
              A little boutique with a big love for Indian fashion
            </h1>
            <div className="text-sm text-[#6E6E69] leading-relaxed mt-5 space-y-4 font-body">
              <p>
                Kurti Connection USA began with a simple frustration: finding beautiful, well-fitting
                Indian ethnic wear in America meant weeks of waiting, uncertain sizes, and no one to
                ask for help. So we built the boutique we wished existed.
              </p>
              <p>
                Every kurti, saree, lehenga and sherwani on our racks is handpicked — many pieces are
                one-of-a-kind, made in small batches by artisans we know. And because fit matters as
                much as fabric, our in-house tailoring studio hems, adjusts and customizes your
                outfit before it ever leaves the store.
              </p>
              <p>
                Visit us in Schaumburg, Illinois and try everything on in person — or shop online with
                free US shipping over $75, virtual try-on, and same-day DoorDash delivery across the
                northwest Chicago suburbs.
              </p>
            </div>
            <div className="flex gap-3 mt-8">
              <Link to="/shop" data-testid="about-shop-cta"
                className="bg-[#1A1A1A] text-[#FFFFFF] px-7 py-3.5 text-[0.7rem] font-mono tracking-[0.2em] uppercase hover:bg-[#B84A3B] transition-colors">
                Shop the Collection
              </Link>
              <Link to="/contact" data-testid="about-contact-cta"
                className="border border-[#1A1A1A] px-7 py-3.5 text-[0.7rem] font-mono tracking-[0.2em] uppercase hover:bg-[#1A1A1A] hover:text-[#FFFFFF] transition-colors">
                Visit Us
              </Link>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-3 border border-[#B84A3B]/30 translate-x-4 translate-y-4" />
            <img src={HERO_IMG} alt="Bridal collection at Kurti Connection USA boutique"
              className="relative w-full aspect-[4/5] object-cover" data-testid="about-image" />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-16">
          {[
            { icon: Store, title: "Real boutique", text: "A physical store you can visit in Schaumburg, IL — not a faceless website." },
            { icon: Scissors, title: "In-house tailoring", text: "Alterations by our own tailor, from hemming to full custom fits." },
            { icon: Sparkles, title: "Virtual try-on", text: "See outfits on yourself before you buy — a boutique first." },
            { icon: Truck, title: "Fast local delivery", text: "Same-day DoorDash delivery within 25 miles of the store." },
          ].map(({ icon: Icon, title, text }) => (
            <div key={title} className="bg-[#FFFFFF] border border-[#E5E5DF] p-5" data-testid={`about-card-${title.toLowerCase().replace(/\s+/g, "-")}`}>
              <Icon size={18} className="text-[#B84A3B]" />
              <h3 className="font-display text-lg mt-2.5">{title}</h3>
              <p className="text-[0.8rem] text-[#6E6E69] mt-1.5 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
